<template>
  <vue-final-modal v-bind="$attrs" :click-to-close="!preventManualClose" overlay-class="Modal__overlay" :content-class="`Modal__content ${modalClass}`">

    <button v-if="!preventManualClose" class="Modal__close" @click="close">
      <Icon name="cross" />
    </button>

    <div class="Modal__header">
      <h3 class="Modal__title">
        <slot name="title"></slot>
      </h3>
    </div>

    <div class="Modal__body">
      <slot></slot>
    </div>

    <div class="Modal__footer">
      <slot name="footer"></slot>
    </div>

  </vue-final-modal>
</template>

<script>
  import { ModalesManager } from '@/store/modales'
  import Icon from '@components/Icon'

  export default {
    components: { Icon },
    name: 'Modal',
    inheritAttrs: false,
    props: [ 'modalClass', 'preventManualClose' ],
    methods: {
      close() {
        if (!this.preventManualClose){
          ModalesManager.close()
          this.$emit('close')
          this.$modal.hideAll()
          document.body.classList.remove('showModal')
        }
      }
    }
  }
</script>

<style lang="scss">
  @import "~@sass/components/_Modal.scss";
</style>
